import api from "./Api";

class FiscalInventarioService {
  GetSnapshots() {
    return api.get("/v1/fiscal/inventarios").then((response) => {
      return response.data;
    });
  }

  GetInventario(id) {
    return api.get(`/v1/fiscal/inventarios/${id}`).then((response) => {
      return response.data;
    });
  }

  PostSnapshot(payload) {
    return api
      .post("/v1/fiscal/inventarios/snapshot", payload)
      .then((response) => {
        return response.data;
      });
  }

  PostInventario(payload) {
    return api.post("/v1/fiscal/inventarios", payload).then((response) => {
      return response.data;
    });
  }

  PutInventario(id, payload) {
    return api.put(`/v1/fiscal/inventarios/${id}`, payload).then((response) => {
      return response.data;
    });
  }

  DeleteInventario(id) {
    return api.delete(`/v1/fiscal/inventarios/${id}`).then((response) => {
      return response.data;
    });
  }

  PutInventarioItem(id, itemId, payload) {
    return api
      .put(`/v1/fiscal/inventarios/${id}/itens/${itemId}`, payload)
      .then((response) => {
        return response.data;
      });
  }

  DeleteInventarioItem(id, itemId) {
    return api
      .delete(`/v1/fiscal/inventarios/${id}/itens/${itemId}`)
      .then((response) => {
        return response.data;
      });
  }

  PrintInventario(id) {
    return api.get(`/v1/fiscal/inventarios/${id}/imprimir`, {
      responseType: "blob",
    });
  }

  ExportInventario(id) {
    return api.get(`/v1/fiscal/inventarios/${id}/exportar`, {
      responseType: "blob",
    });
  }
}

export default new FiscalInventarioService();
